<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[process$, fields$, templates$]"
    [loading]="reconciliationService?.loading$ | async"
></ef-loading-container>
<p-accordion [multiple]="true" (activeIndexChange)="handleOnOpen($event)">
    <p-accordionTab [selected]="true" header="Filters">
        <ef-reconciliation-filters
            [templates]="templates$ | async"
            [userInfo]="userInfo$ | async"
            [showFilterDates]="showFilterDates"
            [showPayPeriods]="showPayPeriods"
            [payPeriodDates]="payPeriodDatesSelectItems$ | async"
            (DateRangeSelected)="onDateRangeSelected($event)"
            (TemplateSelected)="onTemplateSelected($event)"
            (Memorize)="onMemorize($event)"
        ></ef-reconciliation-filters>
    </p-accordionTab>
    <p-accordionTab [selected]="false" header="Select Columns for Display">
        <!-- <p-toolbar>
            <button
                type="button"
                pButton
                pRipple
                label="Share"
                icon="pi pi-share-alt"
                (click)="onShareTemplate($event)"
                class="p-button-secondary p-mr-2"
                pTooltip="Share"
                tooltipPosition="bottom"
            ></button>
        </p-toolbar> -->
        <div style="height: 25vh">
            <ef-reconciliation-file-format
                [items]="fields$ | async"
                (FieldSelected)="onFieldSelected($event)"
                (RowReorder)="onRowReorder($event)"
                (GroupSelected)="onGroupSelected()"
            ></ef-reconciliation-file-format>
        </div>
    </p-accordionTab>
    <p-accordionTab [selected]="true" disabled="true" header="Reconciliation Display">
        <p-message
            severity="info"
            text="To download summary information such as QB pay hours, etc..., UN-check the Employee work date field. The employee work date is a detailed display."
        ></p-message>
        <p-toolbar>
            <button
                type="button"
                pButton
                pRipple
                icon="pi pi-download"
                (click)="DownloadSubject.next()"
                class="p-button-secondary p-mr-2"
                pTooltip="Download"

                tooltipPosition="bottom"
            ></button>
            <button
                type="button"
                id="btnRebuild"
                pButton
                pRipple
                icon="pi pi-replay"
                (click)="onRebuildClicked()"
                class="p-button-secondary p-mr-2"
                label="Rebuild"
                pTooltip="Rebuild"
                tooltipPosition="bottom"
            ></button>
        </p-toolbar>
        <div id="divExport" #divExport style="height: 35vh">
            <ef-reconciliation-export
                *ngIf="visible"
                [items]="reconciliationService?.entities$ | async"
                [fileFormats]="fieldsSelected$ | async"
                [download]="DownloadSubject"
            ></ef-reconciliation-export>
        </div>
    </p-accordionTab>
</p-accordion>
